import React from 'react';
import styled from 'styled-components';
import { useParams, useSearchParams } from 'react-router-dom';

import { FormTitle, Field, AddressField } from '../../components/UI/Form';
import Button from '../../components/UI/Button';
import { orderApi } from '../../api/order';
import FormContainer from '../../components/UI/FormContainer';

const Container = styled.div`
    margin-top: 100px;
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0px;
`;

export default function DeliveryAddress() {
    const [searchParams] = useSearchParams();
    const params = useParams();
    const [formData, setFormData] = React.useState({
        postalCode: '',
        roadAddress: '',
        detailAddress: ''
    });

    const { postalCode, roadAddress, detailAddress } = formData;

    const orderNumber = params.orderNumber || '';
    const nowAddress = searchParams.get('nowAddress') || '';

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    
	const handleChangeAddress = ({postalCode, roadAddress}) => {
		setFormData(prev => ({
			...prev,
			postalCode,
			roadAddress
		}));
	};

    const handleSubmit = () => {
        if(!postalCode || !roadAddress) {
            alert('주소를 입력해주세요.');
            return;
        }

        orderApi.updateDeliveryAddress(orderNumber, formData)
            .then(response => {
                alert('배송지 정보가 성공적으로 변경되었습니다.');
                window.opener.location.reload();
                window.close();
            })
            .catch(error => {
                alert('배송지 정보 변경에 실패했습니다. 다시 시도해주세요.');
            });
    };

    return (
        <Container>
            <FormContainer style= {{ border: 'none' }}>
                <FormTitle>배송지 정보 변경</FormTitle>
                <Field title="변경 전 주소" value={nowAddress}/>
                <AddressField title="변경 후 주소"
                    value={{ postalCode, roadAddress, detailAddress }}
                    onAddressComplete={ handleChangeAddress }
                    onHandleChange={ handleChange }
                />
            </FormContainer>
            <Button buttonText="변경하기" width="400px" onClick={ handleSubmit } />
        </Container>
    );
}